(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .controller('PartController', PartController);

    PartController.$inject = ['$state', '$localStorage', 'Principal', '$log', '$stateParams', 'PartService', 'RegistrationService', '$translate', '$rootScope', 'CartFactory', 'AlertService'];

    function PartController($state, $localStorage, Principal, $log, $stateParams, PartService, RegistrationService, $translate, $rootScope, CartFactory, AlertService) {
        // VARIABLES
        var vm = this;
        vm.lang = $translate.use();
        vm.parts = [];
        vm.bookedParts = [];
        vm.externalLinks = [];
        vm.welcomeImage = $localStorage.projectinfo.image;

        vm.categoryId = $stateParams.id;
        $log.debug('PartController | opening parts for category ', $stateParams.id);

        vm.pageLoaded = pageLoaded;
        vm.book = book;
        vm.back = goBack;

        vm.coExhibitors = [];

        $rootScope.$on('$translateChangeSuccess', function () {
            vm.lang = $translate.use();
            translateComboBoxValues(vm.areas);
            translateStandSystems(vm.parts);
        });

        getExhibitorAuthorities();

        loadParts();
        loadDocuments();
        loadExternalLinks();

        return vm;


        function getExhibitorAuthorities() {
            Principal.identity().then(function(identity) {
                vm.company = identity.company;
                loadCoExhibitors();
            }, function() {
                $log.debug('PartController | ERROR IDENTITY', value);
            });
        }


        function loadParts() {
            $log.debug('PartController | fetch permits');
            PartService.loadPartsForCategory(vm.categoryId).then(successParts, error);
            PartService.loadAreas().then(successAreas, error);

        }

        function loadCoExhibitors() {
            RegistrationService.loadCoExhibitors().then(successCoExhibitors, error);
        }

        function successCoExhibitors(response) {
            vm.coExhibitors = response.data;

            if (vm.coExhibitors && vm.coExhibitors.length > 0 || $localStorage.coExhibitors && $localStorage.coExhibitors.length > 0) {
                vm.coExhibitors.push({id: -8000, company: vm.company});
            }

            var additionalCoExhibitors = 0;
            if ($localStorage.coExhibitors) {
                additionalCoExhibitors = $localStorage.coExhibitors.length;
                angular.forEach($localStorage.coExhibitors, function (ex) {
                    vm.coExhibitors.push(ex);
                });
            }
            PartService.loadExhibitorPermits(additionalCoExhibitors).then(successExhibitorPermits, error);
            PartService.loadParkingPermits(additionalCoExhibitors).then(successParkingPermits, error);

        }

        function loadDocuments() {
            $log.debug('PartController | fetching docuemnts');
            PartService.loadDocumentsForCategory(vm.categoryId).then(successDocuments, error);
        }

        function loadExternalLinks() {
            $log.debug('PartController | fetching external links');
            PartService.loadExternalLinksForCategory(vm.categoryId).then(successExternalLinks, error);
        }

        function successParts(response) {
            $log.debug('PartController | fetched parts:', response.data);
            vm.parts = response.data;
            translateStandSystems(vm.parts);
        }

        function successExhibitorPermits(response) {
            $log.debug('PartController | fetched successExhibitorPermits:', response.data);
            vm.exhibitorPermitsIncluded = response.data;
        }

        function successParkingPermits(response) {
            $log.debug('PartController | fetched successParkingPermits:', response.data);
            vm.parkingPermitsIncluded = response.data;
        }

        function successDocuments(response) {
            $log.debug('PartController | fetched documents:', response.data);
            vm.documents = response.data;
        }

        function successExternalLinks(response) {
            $log.debug('PartController | fetched external links:', response.data);
            vm.externalLinks = response.data;
        }

        function successAreas(response) {
            $log.debug('PartController | fetched areas:', response.data);
            vm.areas = response.data;
            translateComboBoxValues(vm.areas);
        }

        function error(response) {
            $log.debug('PartController | ERROR:', response);
        }

        function translateComboBoxValues(array) {
            var values = [];
            angular.forEach(array, function (value) {
                value.name = value.translations[vm.lang];
                values.push(value);
            });
            array = values;
        }

        function translateStandSystems(array) {
            var values = [];
            angular.forEach(array, function (value) {
                value.name = value.title[vm.lang];
                if (value.availableColors !== undefined) {
                    angular.forEach(value.availableColors, function (color) {
                        color.name = color.translations[vm.lang];
                    });
                }
                values.push(value);
            });
            array = values;
        }

        function pageLoaded() {
            return vm.parts && vm.areas ? true : false;
        }

        function book(partId) {
            $log.debug('PartController | Booking parts.', vm.bookedParts);
            $log.debug('PartController | Part Id', partId);

            angular.forEach(vm.bookedParts, function (part, partIndex) {
                if (partIndex == partId) {
                    var price = getCartPositionPriceForPart(partIndex, part);
                    var bookedFor = getCartPositionBookedFor(part);
                    $log.debug('PartController | Part Price', price);
                    var item = {
                        type: 'Part',
                        areaType: '',
                        cartPositionPrice: price,
                        cartPositionParent: null,
                        cartPositionId: partId,
                        cartPositionLabel: getLabelForPart(partIndex),
                        cartPositionAreaLabel: getAreaLabelForPart(part.partArea),
                        cartPositionColorLabel: getColorLabel(partIndex, part.partColor),
                        cartPositionBookedFor: bookedFor,
                        cartPositionBookedForId: part.coExhibitor,
                        amount: part.partAmount,
                        areaID: part.partArea,
                        bookingOptionColors: [{partId: partIndex, colorId: part.partColor}],
                        id: partId
                    };

                    CartFactory.addItem(item);
                    part.partArea = null;
                    part.coExhibitor = null;
                    part.partColor = null;
                    part.partAmount = null;
                }
            });
            var successMsg = $translate.instant('part.addedToCart');
            AlertService.success(successMsg, {}, 'bottom right');

        }

        function getCartPositionPriceForPart(partId, part) {
            var price = 0;
            angular.forEach(vm.parts, function (p) {
                if (p.id == partId) {
                    price = part.partAmount * p.price;
                    //$log.debug('PartController | Calculating price ', price);
                    return price;
                }
            });

            return price;
        }

        function getCartPositionBookedFor(part) {

            var label = ''
            if (part.coExhibitor) {
                angular.forEach(vm.coExhibitors, function (ex) {
                    if (ex.id == part.coExhibitor) {
                        label = '- ' + ex.company;
                        return;
                    }
                });
            }
            return label;
        }

        function getLabelForPart(partId) {
            var label = "";
            angular.forEach(vm.parts, function (p) {
                if (p.id == partId) {
                    label = p.title;
                    return label;
                }
            });

            return label;
        }

        function getAreaLabelForPart(areaId) {
            var label = "";
            angular.forEach(vm.areas, function (area) {
                if (area.id == areaId) {
                    label = area.translations;
                    return label;
                }
            });

            return label;
        }

        function getColorLabel(partId, colorId) {
            var label = {de: '', en: ''};
            angular.forEach(vm.parts, function (p) {
                if (p.id == partId) {
                    angular.forEach(p.availableColors, function (color) {
                        if (color.id == colorId) {
                            label = color.translations;
                            return label;
                        }
                    });
                }
            });

            return label;
        }

        function goBack() {
            $state.go('category');
        }
    }
})();
